import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './data.service';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CorteCajaService extends BaseService {
  constructor(httpClient: HttpClient, authService: AuthService) {
    super('v1/corte-caja', httpClient, authService);
  }

  crearCorte(dto: any): Observable<any> {
    return this.post(dto, '');
  }

  cerrarCorte(id: number, dto: any): Observable<any> {
    const url = this.getFullUrl(`${id}/cerrar`);
    return this.httpClient.patch(url, dto);
  }

  getDetalle(id: number): Observable<any> {
    return this.get(`${id}/detalle`);
  }

  getCortes(params?: any): Observable<any> {
    return this.get('', params);
  }

  crearCorteDia(dto: { usuarioId: number; fecha?: string; observaciones?: string }): Observable<any> {
    return this.post(dto, 'dia');
  }
}
